import { AxiosInstance, AxiosResponse } from "axios";

export interface SmsResendConfigResponseDTO {
  valor: string;
  empresa: string;
  processo: string;
  codigopacote: string;
}

export const parseSmsResendSeconds = (
  response: SmsResendConfigResponseDTO | undefined,
  fallbackSeconds: number
): number => {
  const seconds = Number(response?.valor);

  return Number.isFinite(seconds) && seconds > 0 ? seconds : fallbackSeconds;
};

export class PhoneVerificationResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  fetchSmsResendConfig(
    empresa: string,
    codigoPacote: string
  ): Promise<AxiosResponse<SmsResendConfigResponseDTO>> {
    const url = `/requisicoes/valor-reenvio-sms`;
    return this.apiProvider.get(url, {
      params: {
        empresa,
        codigoPacote
      }
    });
  }
}
